import { loadLanguage } from '@/language';

// initial state
const state = {
    language: JSON.parse(localStorage.getItem('language')) || {
        language: 'en',
    },
};

// getters
const getters = {
    activeLanguage: s =>
    {
        return s.language.language;
    },
};

// actions
const actions = {
    changeLanguage({commit}, language)
    {
        return new Promise((resolve, reject) =>
        {
            loadLanguage(language).then(
                () =>
                {
                    commit('setLanguage', language);
                    resolve('language');
                }
            ).catch(
                () =>
                {
                    reject('language');
                }
            );
        });
    },
};

// mutations
const mutations = {
    setLanguage(s, language)
    {
        s.language.language = language;

        localStorage.setItem('language', JSON.stringify(s.language));
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
